<template>
<div class="product-rating rating-stars d-none d-md-block mt-auto pb-1">
	<span v-for="i in createRange(0,4)" :key="i" class="icon-stack" style="width:1em">
		<i class="bi bi-star icon-stack-in"></i>
		<span v-if="(rating-i).toFixed(1) > 0">
		<i v-if="(rating-i).toFixed(1) > 0.5" class="bi bi-star-fill icon-stack-in"></i>
		<i v-else class="bi bi-star-half icon-stack-in"></i>
		</span>
	</span>
</div>
</template>

<script>
export default {
    props: {
        rating: String
    },

    methods: {
		createRange(min, max) {
			var range = [];
			for (let i = min; i <= max; i++) {
				range.push(i);
			}
			return range;
		}
    }
}
</script>